<template>
    <div class="index-yn">
        <SwitchTab :diagramType.sync="diagramType" @updateDiagramType="updateDiagramTypeFu"></SwitchTab>
        <HighDiagram v-if="diagramType == 1" />
        <LowDiagram v-else-if="diagramType == 2" />
    </div>
</template>
<script>
import SwitchTab from "./switch-tab-yn.vue";
import HighDiagram from "./components/high-diagram.vue"
import LowDiagram from "./components/low-diagram.vue"
export default {
    components: {
        SwitchTab,
        HighDiagram,
        LowDiagram
    },
    data() {
        return {
            diagramType: 1
        }
    },
    methods: {
        updateDiagramTypeFu(type) {
            this.diagramType = type;
        }
    }
}
</script>
<style lang="scss">
.index-yn {
    position: relative;
    width: 100%;
    height: 100%;
}
</style>